import { Duration } from 'luxon';

const getDurationFromMillis = (millis = 0, format = 'mm:ss') =>
  Duration.fromMillis(millis).toFormat(format);

export default getDurationFromMillis;
